import { Button, Textarea } from "@mui/joy";
import { Backdrop, CircularProgress, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { DataGridPremium, GridFilterModel } from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import { Alert, Autocomplete, Avatar, Box, LinearProgress, Modal, Stack, TextField } from "@mui/material";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Send } from "@mui/icons-material";
import totalLocationData from "../../../data/locationdata";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'background.paper',
    borderRadius: "24px",
    boxShadow: 24,
    p: 3,
    paddingLeft: 5,
    paddingRight: 5
};

const columns = [
    {
        field: "location", headerName: "지점", width: 100
    },
    {
        field: "seat", headerName: "좌석번호", width: 80
    },
    {
        field: "name", headerName: "이름", width: 180
    },
    {
        field: "selected", headerName: "선택", width: 80
    }
]

const FeedbackMessageSend: React.FC<any> = (props: any) => {

    const [rows, setRows] = useState<any>([]);
    const [open, setOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [loading2, setLoading2] = useState<boolean>(false);
    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: [
            {
                id: 1,
                field: "location",
                operator: "contains",
                value: ""
            },
            {
                id: 2,
                field: "name",
                operator: "contains",
                value: ""
            },
            {
                id: 3,
                field: "selected",
                operator: "contains",
                value: ""
            }
        ]
    });
    const [alignment, setAlignment] = useState("total");
    const [alignment2, setAlignment2] = useState("all");
    const [alignment3, setAlignment3] = useState("student");
    const [selectedIds, setSelectedIds] = useState<any>([]);
    const [selectedLocations, setSelectedLocations] = useState<any>([]);
    const [message, setMessage] = useState<string>("");
    const [filloutLink, setFilloutLink] = useState<string>("");
    const [data, setData] = useState<any>([]);

    const [studentData, setStudentData] = useState<any>([]);
    const [parentData, setParentData] = useState<any>([]);

    useEffect(() => {
        getTotalUsersInfo();
    }, []);

    const notify1 = () => toast.success("클립보드에 변수가 저장되었습니다. 원하는 곳에 붙여넣기 해주세요!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    });

    const notify2 = () => toast.success("모든 메세지 전송이 완료되었습니다!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    });

    const notify3 = () => toast.error("메세지 전송 중에 에러가 발생했습니다!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "light"
    });

    const getTotalUsersInfo = async () => {

        try {

            setLoading(true);

            const response = await fetch("https://peetsunbae.com/dashboard/envelope/totaluserinfo", {
                method: "GET",
                headers: { "Content-Type": "application/json" },
                credentials: "include"
            });

            const result = await response.json();

            if (result.message === "success") {
                setStudentData(result.data);
                setParentData(result.data2);
                setData(result.data);
                setLoading(false);
            }

        } catch (e) {

        }

    }

    useEffect(() => {
        makeRows(data);
    }, [data]);

    const makeRows = (data: any) => {

        data.forEach((eachData: any) => {
            if (eachData.studentName) {
                eachData.name = `${eachData.name} (${eachData.studentName} 학부모님)`;
            }
        })

        data.forEach((eachData: any) => {
            if (eachData.location === "강남점") {
                eachData.locationOrder = 1;
            } else if (eachData.location === "대치점") {
                eachData.locationOrder = 2;
            } else if (eachData.location === "대치3층") {
                eachData.locationOrder = 3;
            } else {
                eachData.locationOrder = 0;
            }
        })

        data.sort((a: any, b: any) => {
            if (a.locationOrder < b.locationOrder) {
                return -1;
            } else if (a.locationOrder > b.locationOrder) {
                return 1;
            } else {
                return 0;
            }
        });

        data.forEach((eachData: any, index: number) => {
            if (!eachData.seat || isNaN(+eachData.seat)) {
                eachData.seatOrder = 100000 + index;
            } else {
                eachData.seatOrder = +eachData.seat;
            }
        });

        data.sort((a: any, b: any) => {
            if (a.locationOrder === b.locationOrder) {
                if (a.seatOrder < b.seatOrder) {
                    return -1;
                } else if (a.seatOrder > b.seatOrder) {
                    return 1;
                } else {
                    return 0;
                }
            } else {
                return 0;
            }
        });

        const newRows: any = [];
        const ids: any = [];

        data.forEach((eachData: any) => {

            const oneRow: any = {};

            oneRow.id = eachData.id;

            if (ids.includes(eachData.id)) {
                return;
            }

            ids.push(eachData.id);

            oneRow.chatRoomId = eachData.chatRoomId;
            oneRow.location = eachData.location;
            oneRow.seat = eachData.seat;
            oneRow.name = eachData.name;

            newRows.push(oneRow);
        })

        setRows([...newRows]);

    }

    const handleChangeLocation = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {

        if (!newAlignment) {
            return;
        }

        setAlignment(newAlignment);

        var value = "";

        totalLocationData.forEach((eachLocationData) => {

            if (eachLocationData.filterValue_contains === undefined) {
                return;
            }

            if (eachLocationData.english === newAlignment) {
                value = eachLocationData.filterValue_contains;
            }
        })

        const newFilterModel = { ...filterModel };

        newFilterModel.items.forEach((eachFilter: any) => {
            if (eachFilter.field === "location") {
                eachFilter.value = value;
            }
        });

        setFilterModel({ ...newFilterModel });

    }

    const handleClose = () => {
        setMessage("");
        setFilloutLink("");
        setOpen(false);
    }

    useEffect(() => {

        if (selectedIds.length === 0) {
            const newSelectedLocations: any = [];

            totalLocationData.forEach((eachLocationData) => {
                if (eachLocationData.english === "total") {
                    return;
                }
                newSelectedLocations.push({
                    location: eachLocationData.korean,
                    names: []
                })
            });

            setSelectedLocations([...newSelectedLocations]);
        }

        const selectedLocations: any = [];

        totalLocationData.forEach((eachLocationData) => {
            if (eachLocationData.english === "total") {
                return;
            }
            selectedLocations.push({
                location: eachLocationData.korean,
                names: []
            })
        });

        selectedIds.forEach((eachId: any) => {

            const selectedRow = rows.find((eachRow: any) => eachRow.id === eachId);

            if (selectedRow) {
                const selectedLocation = selectedLocations.find((eachLocation: any) => eachLocation.location === selectedRow.location);
                if (selectedLocation) {
                    selectedLocation.names.push(selectedRow.name);
                }
            }

        });

        setSelectedLocations(selectedLocations);

        const newRows = rows;

        newRows.forEach((eachRow: any) => {
            if (selectedIds.includes(eachRow.id)) {
                eachRow.selected = "✔️";
            } else {
                eachRow.selected = "";
            }
        });

        setRows([...newRows]);

    }, [selectedIds]);

    const handleChange2 = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {

        if (!newAlignment) {
            return;
        }

        setAlignment2(newAlignment);

        var value = "";

        switch (newAlignment) {
            case "all":
                value = "";
                break;
            case "selected":
                value = "✔️";
                break;
        }

        const newFilterModel = { ...filterModel };

        newFilterModel.items.forEach((eachFilter: any) => {
            if (eachFilter.field === "selected") {
                eachFilter.value = value;
            }
        });

        setFilterModel({ ...newFilterModel });

    }

    const handleChange3 = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {

        if (!newAlignment) {
            return;
        }

        setAlignment3(newAlignment);

        if (newAlignment === "student") {
            setData(studentData);
        }

        if (newAlignment === "parent") {
            setData(parentData);
        }

    }

    const copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                notify1();
            })
            .catch(err => {
                console.error('클립보드 복사에 실패했습니다.', err);
                alert('클립보드 복사에 실패했습니다.');
            });
    };

    const handleFilloutLinkChange = (e: any) => {
        const value = e.target.value;
        const stripped = value.includes("?") ? value.split("?")[0] : value;
        setFilloutLink(stripped);
    };

    const letsSendFeedbackMessages = async () => {

        try {

            if (!message) {
                return;
            }

            if (!filloutLink) {
                return;
            }

            if (selectedIds.length === 0) {
                return;
            }

            handleClose();
            setLoading2(true);

            const response = await fetch("https://peetsunbae.com/dashboard/envelope/sendFeedbackMessages", {
                method: "post",
                headers: {
                    "content-type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify({
                    message, filloutLink, selectedIds
                })
            });

            const result = await response.json();

            setLoading2(false);

            if (result.message === "success") {
                notify2();
            } else {
                notify3();
            }

        } catch (e) {

            setLoading2(false);
            notify3();
        }

    }

    return (
        <div>
            <div style={{
                display: "flex",
                justifyContent: "center",
            }}>
                <div style={{
                    width: "1200px",
                    paddingBottom: "100px"
                }}>
                    <div style={{
                        marginBottom: "16px"
                    }}>
                        <ToggleButtonGroup
                            color="primary"
                            value={alignment3}
                            exclusive
                            onChange={handleChange3}
                        >
                            <ToggleButton value="student">학생</ToggleButton>
                            <ToggleButton value="parent">학부모</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                    <div style={{
                        marginBottom: "16px"
                    }}>
                        <ToggleButtonGroup
                            color="primary"
                            value={alignment2}
                            exclusive
                            onChange={handleChange2}
                        >
                            <ToggleButton value="all">ALL</ToggleButton>
                            <ToggleButton value="selected">selected</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                    <div style={{
                        marginBottom: "16px",
                        display: "flex",
                        justifyContent: "space-between"
                    }}>
                        <div>
                            <ToggleButtonGroup
                                color="primary"
                                value={alignment}
                                exclusive
                                onChange={handleChangeLocation}
                            >
                                {
                                    props.user && totalLocationData.filter(locationData => locationData.academy.includes(props.user.academy)).map((eachLocationData, index) => {
                                        return (
                                            <ToggleButton value={eachLocationData.english} key={index}>{eachLocationData.korean}</ToggleButton>
                                        )
                                    })
                                }
                            </ToggleButtonGroup>
                        </div>
                        <div>
                            <TextField
                                label="이름"
                                variant="standard"
                                size="small"
                                style={{
                                    width: "200px"
                                }}
                                onChange={(e) => {
                                    const newFilterModel = { ...filterModel };

                                    newFilterModel.items.forEach((eachFilter: any) => {
                                        if (eachFilter.field === "name") {
                                            eachFilter.value = e.target.value;
                                        }
                                    });

                                    setFilterModel({ ...newFilterModel });
                                }}
                            />
                        </div>
                    </div>
                    <div style={{
                        height: "800px"
                    }}>
                        <DataGridPremium
                            rows={rows}
                            columns={columns}
                            checkboxSelection
                            disableRowSelectionOnClick
                            density="compact"
                            loading={loading}
                            filterModel={filterModel}
                            onFilterModelChange={(model) => {
                                setFilterModel(model);
                            }}
                            onRowSelectionModelChange={(model) => {
                                setSelectedIds(model);
                            }}
                        />
                    </div>

                    <div style={{
                        marginTop: "16px",
                        display: "flex",
                        justifyContent: "flex-end"
                    }}>
                        <Button variant="soft" color="primary"
                            disabled={selectedIds.length === 0}
                            onClick={() => {
                                setOpen(true);
                            }}
                        >피드백 요청하기
                        </Button>
                    </div>
                </div>
            </div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div style={{
                        fontFamily: "Apple_B",
                        fontSize: "20px",
                        marginBottom: "16px"
                    }}>
                        피드백 메세지 보내기
                    </div>
                    <div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            fontSize: "16px",
                            marginBottom: "6px"
                        }}>
                            보낼 대상
                        </div>
                        <div>
                            {
                                selectedLocations.map((eachLocation: any, index: number) => {
                                    if (eachLocation.names.length === 0) {
                                        return null;
                                    }

                                    var isNeedComma = true;

                                    if (index === selectedLocations.length - 1) {
                                        isNeedComma = false;
                                    } else if (selectedLocations[index + 1].names.length === 0) {
                                        isNeedComma = false;
                                    }

                                    return (
                                        <span key={index}>
                                            {eachLocation.location} {eachLocation.names.length}명
                                            {
                                                isNeedComma ? ", " : ""
                                            }
                                        </span>
                                    )
                                })
                            }
                        </div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            fontSize: "16px",
                            marginBottom: "8px",
                            marginTop: "16px"
                        }}>
                            보낼 메세지
                        </div>
                        <div>
                            <Textarea minRows={6} maxRows={6}
                                value={message}
                                onChange={(e) => {
                                    setMessage(e.target.value);
                                }}
                            />
                        </div>
                        <div style={{
                            marginTop: "8px"
                        }}>
                            <Button variant="soft" color="neutral"
                                onClick={() => {
                                    copyToClipboard("#{이름+}");
                                }}
                            >
                                이름(성포함) 변수
                            </Button>
                            <Button variant="soft" color="neutral"
                                onClick={() => {
                                    copyToClipboard("#{이름-}");
                                }}
                                style={{
                                    marginLeft: "8px"
                                }}
                            >
                                이름(성제외) 변수
                            </Button>
                        </div>
                        <div style={{
                            fontFamily: "Apple_SB",
                            fontSize: "16px",
                            marginBottom: "8px",
                            marginTop: "16px"
                        }}>
                            보낼 Fillout 링크
                        </div>
                        <div>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                value={filloutLink}
                                onChange={handleFilloutLinkChange}
                                placeholder="설문 링크를 입력해주세요 (? 뒤 파라미터는 자동 제거됩니다)"
                            />
                        </div>

                        <div>
                            <Button variant="soft" color="primary"
                                style={{
                                    marginTop: "32px"
                                }}
                                size="lg"
                                fullWidth
                                startDecorator={
                                    <Send />
                                }
                                disabled={!message || !filloutLink}
                                onClick={() => {
                                    letsSendFeedbackMessages();
                                }}
                            >
                                보내기
                            </Button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading2}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

        </div>
    )
}

export default FeedbackMessageSend;
